import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  // existing category fields
  categoryId: "",
  category: "",
  code: "",
  description: "",
  active: true,

  // new list-related fields (from generalBranch)
  categoryAll: [],
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    // existing
    setCategoryData: (state, action) => {
      const { categoryId, category, code, description, active } = action.payload;
      state.categoryId = categoryId;
      state.category = category;
      state.code = code;
      state.description = description;
      state.active = active;
    },

    clearCategoryData: (state) => {
      state.categoryId = "";
      state.category = "";
      state.code = "";
      state.description = "";
      state.active = true;
    },

    // new — for list handling and pagination
    setCategoryAll: (state, action) => {
      state.categoryAll = action.payload;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },

    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },

    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },

    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
  },
});

export const {
  setCategoryData,
  clearCategoryData,
  setCategoryAll,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
  setSortBy,
  setSortOrder,
} = categorySlice.actions;

export default categorySlice.reducer;
